<custom-modal-card
  *ngIf="{
    violations: violations$ | async,
    tag: tag()
  } as STATE"
  class="edit-attachment mat-dialog-transparent"
>
  <ng-container header>
    <default-modal-header
      [title]="modalTitle"
      [description]="modalDescription"
    ></default-modal-header>
  </ng-container>
  <ng-container body>
    <form
      [formGroup]="form"
      id="tag"
      (ngSubmit)="onSubmit()"
      class="resource-form"
    >
      <article>
        <mat-label>Intitulé *</mat-label>
        <mat-form-field color="primary">
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <input
            formControlName="title"
            matInput
            placeholder="Entrez l'intitulé du tag"
          />
        </mat-form-field>
        <mat-error *ngIf="form.get('name')?.getError('httpError') as httpError">
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Algorithme *</mat-label>
        <mat-form-field>
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <mat-select formControlName="algorithmId">
            <mat-option
              *ngFor="let algorithm of algorithms"
              [value]="algorithm.value"
            >
              {{ algorithm.value | tagAlgorithm }}
            </mat-option>
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('algorithm')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
    </form>
  </ng-container>

  <footer footer class="resource-form">
    <button
      type="submit"
      [attr.loading]="isSubmitting()"
      [disabled]="form.invalid || isSubmitting() || form.pristine"
      class="btn btn--primary-light btn--full"
      form="tag"
    >
      {{ STATE.tag ? 'Mettre à jour les informations' : 'Créer le tag' }}
    </button>
  </footer>
</custom-modal-card>
